// src/components/User/AppContext.js
import React, { createContext, useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase';  // ✅ your named export

export const AppContext = createContext({
    settings: null,
    projectHighlights: null,
    developersData: null,
    loading: true,
    error: null,
});

export const AppProvider = ({ children }) => {
    const [settings, setSettings] = useState(null);
    const [projectHighlights, setProjectHighlights] = useState(null);
    const [developersData, setDevelopersData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        (async () => {
            try {
                const [sSnap, hSnap, dSnap] = await Promise.all([
                    getDoc(doc(db, 'propxplorer', 'settings')),
                    getDoc(doc(db, 'propxplorer', 'project-highlights')),
                    getDoc(doc(db, 'propxplorer', 'developers')),
                ]);

                if (sSnap.exists()) setSettings(sSnap.data());
                if (hSnap.exists()) setProjectHighlights(hSnap.data());
                if (dSnap.exists()) setDevelopersData(dSnap.data());
            } catch (err) {
                console.error(err);
                setError(err);
            } finally {
                setLoading(false);
            }
        })();
    }, []);

    return (
        <AppContext.Provider value={{ settings, projectHighlights, developersData, loading, error }}>
            {children}
        </AppContext.Provider>
    );
};
